import { Barbell, Fire, Lightning, Medal, Trophy } from "@phosphor-icons/react";
import { FADE_UP, motion, stagger, formatDateShort } from "./constants";

const BADGE_ICONS = { Barbell, Fire, Lightning, Medal, Trophy };

const ACCENT_BY_CATEGORY = {
  workouts: "#007AFF",
  streak: "#FF9500",
};
const DEFAULT_ACCENT = "#D4FF00";

export default function RecentBadgesCard({ badges, onNavigate }) {
  return (
    <div className="stat-card lg:col-span-2" data-testid="recent-badges-card">
      <div className="flex items-center justify-between mb-4">
        <h3
          className="text-lg font-bold tracking-tight uppercase text-white flex items-center gap-2"
          style={{ fontFamily: "Barlow Condensed, sans-serif" }}
        >
          <Trophy size={18} weight="fill" className="text-[#D4FF00]" />
          BADGE SBLOCCATI DI RECENTE
        </h3>
      </div>
      {badges.length > 0 ? (
        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-6 gap-2">
          {badges.map((b, i) => {
            const Icon = BADGE_ICONS[b.icon] || Medal;
            const accent = ACCENT_BY_CATEGORY[b.category] || DEFAULT_ACCENT;
            return (
              <motion.div
                key={`${b.client_id}-${b.badge_code}`}
                {...FADE_UP}
                transition={stagger(0.1, 0.05, i)}
                onClick={() => onNavigate(`/clients/${b.client_id}`)}
                className="cursor-pointer p-3 rounded-lg bg-[#0A0A0A] border border-[#1A1A1A] hover:border-[#262626] transition-colors"
                data-testid={`recent-badge-${i}`}
              >
                <div
                  className="w-9 h-9 rounded-lg flex items-center justify-center mb-2"
                  style={{ backgroundColor: `${accent}22`, border: `1px solid ${accent}55` }}
                >
                  <Icon size={16} weight="fill" style={{ color: accent }} />
                </div>
                <p className="text-xs font-semibold text-white truncate">{b.name}</p>
                <p className="text-[10px] text-zinc-500 truncate">{b.client_name}</p>
                <p className="text-[9px] text-zinc-600 mt-0.5">{formatDateShort(b.unlocked_at)}</p>
              </motion.div>
            );
          })}
        </div>
      ) : (
        <div className="text-center py-6">
          <Medal size={28} weight="duotone" className="text-zinc-600 mx-auto mb-2" />
          <p className="text-zinc-500 text-sm">Nessun badge sbloccato ancora</p>
        </div>
      )}
    </div>
  );
}
